import { atom, useAtom } from 'jotai';
import { currentStepAtom } from './onboardingAtoms';

export const isRecalculatingHSAAtom = atom(false);

export const setISRecalculatingHSAAtom = atom(
  null,
  (_, set, isRecalculating: boolean) => {
    set(currentStepAtom, isRecalculating ? 2 : 0);
    set(isRecalculatingHSAAtom, isRecalculating);
  }
);

export const useIsRecalculatingHSA = () => useAtom(isRecalculatingHSAAtom);
